import React, { Component } from 'react';
import Papa from 'papaparse'
import { Table, Button, Form } from 'semantic-ui-react';
import * as UiConsts from '../../../../config/UiConstants';
import { serverIp, firebaseAuth, logComponentLoad} from '../../../../config/constants.js'
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import axios from 'axios'

class ExpensesUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            loading: false,
            sessionId: ''
        }
        this.updateData = this.updateData.bind(this);
    }


    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ExpensesUpload");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }


    handleChange = event => {
        this.setState({
            csvfile: event.target.files[0]
        });
    };

    importCSV = () => {
        const { csvfile } = this.state;
        Papa.parse(csvfile, {
            complete: this.updateData,
            header: true
        });
    };

    updateData(result) {
        var data = result.data;
        console.log(JSON.stringify(data, null, 3));

        let sessionId = Math.random().toString(36).substring(2, 7) + Math.random().toString(36).substring(2, 7);
        console.log("code set to:" + sessionId)
        this.setState({ list: data, sessionId: sessionId })
    }

    sendList = () => {
        this.setState({ loading: true });
        console.log("+++++++++++:sendList :++++++");
        // SEND CHECK TO SERVER
        console.log("serverIpxx1:"+serverIp);
        axios.post(serverIp + 'billing/uploadExpenseList', {
            apiKey: "ExpensesUpload",
            expenseList: this.state.list,
            adminEmail: this.state.user.email,
            sessionId: this.state.sessionId
        })
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                console.log("entx22 result:" + response.data.result);

                // CHECK RECEIPTS
                if (response.data.result) {

                    this.setState(
                        {
                            loading: false,
                            list: [],
                            sessionId: ''
                        });
                    alert("Success:" + response.data.message);

                    // CHECK ORDER NUMBER
                } else if (!response.data.result) {
                    alert("Error:" + response.data.message);
                    this.setState({ loading: false });
                }

                //this.clearFields();

            })
            .catch((error) => {
                console.log(error);
                alert("upload failed!!!:" + error);
                //this.setState({ loading: false })
                //this.clearFields();
            });
    }

    render() {

        const rows = this.state.list.length > 0
            ? this.state.list.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.daDate} </Table.Cell>
                    <Table.Cell> {item.item} </Table.Cell>
                    <Table.Cell>{item.qty}</Table.Cell>
                    <Table.Cell>{new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'UGX' }).format(item.price)}</Table.Cell>
                    <Table.Cell>{new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'UGX' }).format(item.price * item.qty)}</Table.Cell>
                    <Table.Cell>{item.order_num}</Table.Cell>
                    <Table.Cell>{item.comments}</Table.Cell>
                    {/* <Table.Cell><Button color='red'>PAY</Button></Table.Cell> */}
                </Table.Row>)
            : ''

        const daTable = this.state.list.length > 0
            ? <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>Item</Table.HeaderCell>
                        <Table.HeaderCell>Qty</Table.HeaderCell>
                        <Table.HeaderCell>Price</Table.HeaderCell>
                        <Table.HeaderCell>Total Price</Table.HeaderCell>
                        <Table.HeaderCell>Order Number </Table.HeaderCell>
                        <Table.HeaderCell>Comments </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {rows}
                </Table.Body>
            </Table>
            : ''

        
        const sendToApiUI = this.state.list.length > 0
            ? <Form onClick={this.sendList}>
                <Button>SEND LIST</Button>
            </Form>
            : ''

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'


            const wholeUI = this.state.algoliaUser
            && this.state.algoliaUser != ''
            && this.state.algoliaUser.perms
            && this.state.algoliaUser.perms.includes("expensesUpload")
            ? <div>

                <h2>Import CSV File!</h2>
                <h2>SESSION ID:{this.state.sessionId}</h2>
                <input
                    className="csv-input"
                    type="file"
                    ref={input => {
                        this.filesInput = input;
                    }}
                    name="file"
                    placeholder={null}
                    onChange={this.handleChange}
                />
                <p />
                <button onClick={this.importCSV}> Upload now!</button>
                {daTable}
                {sendToApiUI}

            </div>
            : <div><h2>AN ERROR OCCURED</h2>{userEmail}</div>

        return (

            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                {wholeUI}
            </div>
        );
    }
}

export default ExpensesUpload;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ExpensesUpload/ExpensesUpload.js